import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import EmptyPage from '../../empty-page/emptyPage';
import OrgTripList from '../../orgTripList/OrgTripList';
import { countOfGuidePackages, orgfetchGuidPackList } from './orgGuidePackListFn/orgGuidPackListFn';
import Pagination from '../../pagination/Pagination';

const OrgGuidPackList = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const selectedStatus = searchParams.get('status') || 'active';
    const pageNumber = Number(searchParams.get('page')) || 1;
    const [guidData, setGuidData] = useState([]);
    const limit = 10;
    const [totalCount, setTotalCount] = useState(0);
    const offSet = (pageNumber - 1) * limit;
    const totalData = totalCount;
    const totalPages = Math.ceil(totalData / limit);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    const updateURL = useCallback(
        (params) => {
            const current = Object.fromEntries([...searchParams]);

            Object.keys(params).forEach((key) => {
                if (params[key] === '' || params[key] === null) {
                    delete current[key];
                } else {
                    current[key] = params[key];
                }
            });
            setSearchParams(current);
        },
        [searchParams, setSearchParams]
    );

    useEffect(() => {
        if (!totalPages) return;

        if (pageNumber > totalPages) {
            updateURL({ page: totalPages });
        }
        //eslint-disable-next-line
    }, [totalPages, pageNumber, updateURL]);

    const paginationClick = (number, offSetNumber) => {
        if (Math.ceil(totalData / limit) > 1) {
            updateURL({ page: number });
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };

    useEffect(() => {
        const fetchGuidPackList = async () => {
            try {
                await orgfetchGuidPackList(setGuidData, selectedStatus, limit, offSet, setLoading);
            } catch (error) {}
        };
        fetchGuidPackList();
    }, [selectedStatus, limit, offSet]);

    useEffect(() => {
        countOfGuidePackages(setTotalCount, selectedStatus, setLoading);
    }, [selectedStatus]);

    const handleSelect = (id) => {
        const url = `/org/g/details/${id}`;
        window.open(url, '_blank');
    };

    const handleEdit = (id, type = 'edit') => {
        const url = `/org/g/create/pack?new=false&type=${type}&guideId=${id}`;
        window.open(url, '_blank');
    };

    const handleDuplicate = (id, type = 'duplicate') => {
        const url = `/org/g/create/pack?new=false&type=${type}&guideId=${id}`;
        window.open(url, '_blank');
    };

    return (
        <div>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgPack'>
                {/* discuss on whether we need filters in mybooking */}
                {/* <Filters filterData={filterDummy?.data} /> */}
                {/* <Filters filterData={[]} /> */}
                <div className='orgPackTripStrap'>
                    <div className='orgPackHeadSeaDiv alignCenter'>
                        <h1 className='orgBookingHeading'>My Guides</h1>
                        <div className='orgPackFilters'>
                            <select
                                name='date'
                                id='date'
                                className='select'
                                onChange={(e) => {
                                    updateURL({ status: e.target.value, page: 1 });
                                }}
                                value={selectedStatus}
                            >
                                <option value='active'>Approved</option>
                                <option value='inactive'>Not Approved</option>
                                <option value='rejected'>Rejected</option>
                            </select>
                            <button className='orgPackCreateBtn blueBtn' onClick={() => navigate('/org/g/create/pack')}>
                                Create {window.innerWidth < 768 ? '' : 'Guide'}
                            </button>
                        </div>
                    </div>

                    {/* {searchRe && <p>Search result for {searchRe}</p>} */}
                    {guidData?.length === 0 && !loading ? (
                        <EmptyPage />
                    ) : (
                        <>
                            <OrgTripList
                                data={guidData}
                                onSelect={handleSelect}
                                onEdit={handleEdit}
                                onDuplicate={handleDuplicate}
                                selectedStatus={selectedStatus}
                            />
                            <Pagination
                                paginationClick={paginationClick}
                                numberOfRows={totalData}
                                offSet={offSet}
                                pageNumber={pageNumber}
                                limit={limit}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OrgGuidPackList;
